import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqMetadata');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'chat',
  type: 'get',
  slug: [
    'participant_meta',
    {
      type: 'payload.query',
      queryParameter: 'channel_id',
      selector: 'channelId',
    },
    {
      type: 'payload.query',
      queryParameter: 'ids',
      selector: 'ids',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqMetadata.js